import { useEffect ,useState} from "react";
import axiosInstance from "../../../api/axios";
import { TrumanApplicationList } from "../../../utils/constants";

const useLastModifiedUsers = ({ history, historyInfo }) => {
  const [modifiedUsers, setModifiedUsers] = useState([]);
  const [loader, setLoader] = useState(true);
  const fetchWithToken = async (url) => {
    const token = localStorage.getItem("accessToken") || "";
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return response.json();
  };
  const getApplicationData = (id) => {
    try {
      const applicationData = TrumanApplicationList?.find(
        (app) => app?.oid == id
      );
      return { id, displayName: applicationData?.displayName };
    } catch (secondError) {
      return { id, error: true };
    }
  };

  const fetchAzureADData = async (id) => {
    try {
      const response = await axiosInstance.get(`/entra_user_info/${id}`);
      try {
        if (response?.data?.statusCode == 200 && response?.data?.display_name) {
          return { id, displayName: response?.data?.display_name };
        }
        return getApplicationData(id);
      } catch (e) {}

      return { id, displayName: response?.display_name };
    } catch (firstError) {
      return getApplicationData(id);
    }
  };

  const setObjectIdArray = (info, history) => {
    const ids = [];
    if (info?.last_modified_by_id) ids.push(info?.last_modified_by_id);
    if (history?.length) {
      history?.forEach((item) => {
        if (item?.last_modified_by_id) ids.push(item?.last_modified_by_id);
      });
      const uniqueIds = Array.from(new Set([...(ids || [])]));
      return uniqueIds;
    }
    return ids;
  };
  const fetchAzureAdData = async () => {
    const oIds = setObjectIdArray(historyInfo, history);
    setLoader(true);
    const results = await Promise.all(oIds?.map((id) => fetchAzureADData(id)));
    setModifiedUsers(results || []);
    setLoader(false);
  };
  useEffect(() => {
    if (historyInfo) fetchAzureAdData();
    else setLoader(false);
  }, [historyInfo]);

  return { modifiedUsers, loader };
};

export default useLastModifiedUsers;
